<template>
	<v-card>
		<v-card-title><translate>Pay with Bank Transfer</translate></v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="auto">
					<translate>Bank Account Number</translate>:
					{{ ibanNumber }}
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="auto">
					<translate>Name</translate>:
					{{ companyName }}
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="auto">
					<translate>O.v.v.</translate>:
					Tulip assist factuurnummer {{ invoiceIdentifier }}
				</v-col>
			</v-row>
			<v-row>
				<v-col class="text-orange">
					<translate>Paying by bank transfer delays the processing of your order by at least 1 business day. Pay via iDeal for the fastest processing of your order.</translate>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import Configuration from '../../mixins/Configuration';
export default {
	name: 'BankTransferCard',
	mixins: [Configuration, ],
	props: {
		invoiceIdentifier: {
			required: true,
			type: String,
		},
		ibanNumber: {
			required: true,
			type: String,
		}
	},

	data () {
		return {
			companyName: '',
		};
	},
	created () {
		this.stget('company_name').then((configVariable) => {
			this.companyName = configVariable;
		});
	}
};
</script>

<style scoped>

</style>
